import React from 'react';
import '../styles/spinner.css';

export default function Spinner(props) {
  return (

      <div className={props.className}>
        <div></div>
        <div></div>
      </div>

  )
}



// WEBPACK FOOTER //
// ./src/components/Spinner.js